var colors = {
  black: {
    0: '#000000',
    1: '#212121',
    2: '#2B2B2C',
    3: '#515151',
    4: '#282828'
  },
  gray: {
    1: '#6D6D72',
    2: '#9A9A9E',
    3: '#D6D6D9',
    4: '#E8E8E8',
    5: '#F1F1F2'
  },
  white: {
    1: '#FFFFFF',
    2: '#F6F6F6',
    3: '#FAFAFB'
  },
  negative: {
    1: '#F43A3A',
    2: '#FE6762'
  },
  positive: {
    1: '#149469',
    2: '#7FF0BA'
  },
  accent: {
    1: '#E56E17',
    2: '#E56E17'
  },
  warning: {
    1: '#DF951F',
    2: '#FFB641'
  },
  dark: {
    1: '#363638',
    2: '#262626',
    3: '#202020',
    4: '#1B1B1B',
    5: '#1A1A1A',
    6: '#262626'
  },
  light: {
    1: '#F8F8F8',
    2: '#EEEEEE',
    3: '#DADADA',
    4: '#EEF0F0'
  }
};
export default colors;